import { z } from 'zod'

export const TotpSetup = z.object({
  req_id: z.number().int(),
  secret_key: z.string(),
  webp_image: z.string(),
  jpg_image: z.string()
})

export type TotpSetup = z.infer<typeof TotpSetup>
